// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"dc551e43","455":"e32628bc","650":"50badc43","977":"10d050ce"}[chunkId] + ".chunk.js";
};